import { OpenFeature } from '@openfeature/react-sdk';
import { DatadogProvider } from '@datadog/openfeature-browser';


function createProvider() {
  // Use esse exemplo para testar feature flags localmente, sem precisar de um provider externo
  // if (import.meta.env.VITE_DD_ENV === 'dev') {
  //   return new TypedInMemoryProvider({
  //     'organization-switcher': {
  //       variants: { enabled: true, disabled: false },
  //       defaultVariant: 'disabled',
  //       disabled: false,
  //       contextEvaluator: ctx =>
  //         typeof ctx?.targetingKey === 'string' &&
  //         ORGANIZATION_SWITCHER_DEV_USERS.includes(ctx.targetingKey)
  //           ? 'enabled'
  //           : 'disabled',
  //     },
  //   });
  // }

  const isProd = import.meta.env.VITE_DD_ENV === 'prd';

  return new DatadogProvider({
    applicationId: isProd
      ? import.meta.env.VITE_DD_APP_ID_PROD
      : import.meta.env.VITE_DD_APP_ID_HML,
    clientToken: isProd
      ? import.meta.env.VITE_DD_CLIENT_TOKEN_PROD
      : import.meta.env.VITE_DD_CLIENT_TOKEN_HML,
    site: 'us3.datadoghq.com',
    env: import.meta.env.VITE_DD_ENV,
    enableExposureLogging: true,
    enableFlagEvaluationTracking: true,
  });
}

export const providerReady = OpenFeature.setProviderAndWait(createProvider());

export async function setFeatureFlagContext(userEmail: string): Promise<void> {
  await OpenFeature.setContext({
    targetingKey: userEmail,
  });
}
